module.exports = __webpack_public_path__ + "img/app-store.a111d976.svg";